`use strict`;

import Xhr from '../libs/xhr';

window.initMap = () => {
    window.map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: 45.948284, lng: 24.753145 },
        zoom: 8,
        mapTypeId: 'hybrid'
    });
}

class CampanieVinLaTerasa {
    constructor() {
        this.mapBounds = new google.maps.LatLngBounds();
        this.infowindow = new google.maps.InfoWindow();

        this.getMapMarkers();
    }

    getMapMarkers()
    {
        return new Promise((resolve, reject) => {
            let options = {
                url: window.Laravel.getPartnersLocations,
                method: 'get',
                data: {},

                success: (data) => {
                    $.each(data, (index, partnerLocation) => this.placeMarker(partnerLocation));
                    window.map.fitBounds(this.mapBounds);
                },

                error: function(xhr) {
                    reject(xhr.responseJson);
                }
            };

            let xhr = new Xhr();
            xhr.setOptions(options);
            xhr.execute();
        });
    }

    placeMarker(partnerLocation)
    {
        let markerData = {
            position: {
                lat: partnerLocation.lat,
                lng: partnerLocation.lng
            },
            map: window.map,
            title: partnerLocation.commercial_name
        };

        let marker = new google.maps.Marker(markerData);

        let infoWindowContent = `<div class="map-info-window-content">` +
                `<p><h4>${partnerLocation.commercial_name}</h4><br>` +
                `${partnerLocation.address}<br>` + 
                `${partnerLocation.city.name}, ${partnerLocation.region.name}<br><br>` +
                `<img src="${partnerLocation.logoUrl}" alt="logo" width="150" height="auto" /></p>` +
            `</div>`;

        marker.addListener('click', () => {
            this.infowindow.close();
            this.infowindow.setContent(infoWindowContent);
            this.infowindow.open(window.map, marker);
        });

        this.mapBounds.extend(marker.getPosition());
    }
}

$(() => new CampanieVinLaTerasa());
